export default __webpack_public_path__ + "static/media/logo.bdbd1f7e.webp";